import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _AmortizationType } from '../../../../core/services/dataBean/EntityCatalog';
import { _LoanAccountantConcept, _LoanLine } from '../../../../core/services/dataBean/EntityCatalogVdos';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    LoanLine?: any;
}

export const LoanConceptSelect = ({ idSelector, onChange, label, LoanLine }: Props) => {

    const loanAccountantConcept = useDataBean(_LoanAccountantConcept);
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }


    const getLista = () => {

        loanAccountantConcept.instance.getLoanAccountantConceptCatalog(LoanLine).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Configuración Contable:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDLoanAccountantConcept} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}